import { VehicleOwnerKind } from '@core/models/swagger';
import { LiabilityClaimsNumberEnum, PreviousInsuranceDurationEnum } from './enums';

export const SUPPORTED_LANGUAGES = ['de'];
export const APP_DEFAULT_LANGUAGE = 'de';
export const MIN_PREMIUM_THRESHOLD = -5;
export const MAX_PREMIUM_THRESHOLD = 5;
export const HEADER_X_TOKEN = 'X-Token';
export const HEADER_X_REFRESH_TOKEN = 'X-Refresh-Token';
export const HEADER_GWCOOKIE = 'GWCOOKIE';
export const BRANCH_PATH_PARAM = 'branchId';
export const PARTNERHIP_CUSTOM_BEHAVIOUR = ['0281', '4013'];
export const ICON_CAR = 'verti-car-alt-24';
export const ICON_VAN = 'verti-truck-de-24';
export const ICON_MOTO = 'verti-moto-alt-16';
export const DEFAULT_PARTNERSHIP_ID_VERTIWEB = '0099';
export const DEFAULT_PARTNERSHIP_SHORTNAME_VERTIWEB = 'VRW';
export const COOKIE_PARTNERSHIP_ID = 'ptId';
export const COOKIE_PARTNERSHIP_SHORT_NAME = 'alliance';
export const MGM_LINK = 'https://www.verti-empfehlen.de/?mtm_campaign=Web-quote-buy&mtm_source=verti-quote-buy';
export const RATING_LINK = 'https://de.trustpilot.com/review/verti.de';
export const VERTI_URL = 'https://www.verti.de/';
export const REFERRAL_CODE_ID = 'ZZ';
export const REFERRAL_CODE_ID_URL = 'ZY';
export const REFERRAL_CODE_COOPERATION_ID = 'ZZ';
export const REFERRAL_CODE_MARKETING_ID = '7055TF03';
export const NONE = 'NONE';
export const PARAMS_WHITELIST = ['CAMPAIGN_CODE', 'PROMOTION_CODE', 'REFERRAL_CODE'];
export const VERTI_INSURER_CODE = '5055';
export const DEFAULT_TITLE = 'NONE';
export const DOCUMENTS_NAME = {
  summary: 'Zusammenfassung',
  conditions: 'Bedingungen',
  vertiSummary: 'VertiZusammenfassung',
} as const;

export const MOBILE_MAX_SIZE = 765;
export const TABLET_MAX_SIZE = 991;
export const DESKTOP_MIN_SIZE = 992;

// All URL parameters that can be received in the flow (excluding custom params)
export const URL_PARAMS = {
  utm_source: 'utm_source',
  utm_medium: 'utm_medium',
  utm_campaign: 'utm_campaign',
  utm_term: 'utm_term',
  utm_content: 'utm_content',
  utm_id: 'utm_id',
  partner_id: 'partnerid',
  gclid: 'gclid',
  click_id: 'click_id',
  dclid: 'dclid',
  gad_source: 'gad_source',
  fbclid: 'fbclid',
  msclkid: 'msclkid',
  gtm_debug: 'gtm_debug',
  twclid: 'twclid',
  ttclid: 'ttclid',
  s_id: 's_id',
  qs: 'qs',
  ak: 'ak',
  entrypoint: 'entrypoint',
  empfehlung: 'empfehlung',
  ch: 'ch',
  einsprungsquelle: 'einsprungsquelle',
  nr: 'nr',
  empfaenger: 'empfaenger',
};

// Special SF Class
export const SF_S = 'SF_S';
export const SF_M = 'SF_M';

export const FOOTER_LINKS = [
  {
    label: 'Impressum',
    type: 'link',
    href: 'https://www.verti.de/impressum/',
    lang: 'de',
    target: '_blank',
  },
  {
    label: 'Datenschutz',
    type: 'link',
    href: 'https://www.verti.de/datenschutz/',
    lang: 'de',
    target: '_blank',
  },
  {
    label: 'Cookies konfigurieren',
    type: 'cookies_management',
    lang: 'de',
  },
  {
    label: 'Erklärung zur Barrierefreiheit',
    type: 'link',
    href: 'https://www.verti.de/barrierefreiheit/',
    lang: 'de',
    target: '_blank',
  },
  {
    label: 'Copyright 2025',
    type: 'copyright',
    lang: 'de',
  },
] as const;

export const OCCUPATIONS = [
  { parameterId: 'Employee', parameterName: 'Angestellte' },
  { parameterId: 'EmployeePublicService', parameterName: 'Angestellte im öffentlichen Dienst' },
  { parameterId: 'PostRailwayTelecom', parameterName: 'Beschäftigte (Post/Bahn/Telekom)' },
  { parameterId: 'BankInsurance', parameterName: 'Beschäftigte (Bank/Versicherung)' },
  { parameterId: 'Worker', parameterName: 'Arbeitende' },
  { parameterId: 'WorkerPublicService', parameterName: 'Arbeitende (ÖD)' },
  { parameterId: 'Official', parameterName: 'Verbeamtete' },
  { parameterId: 'Pensioner', parameterName: 'Personen im Ruhestand' },
  { parameterId: 'PensionerPublicService', parameterName: 'Personen im Ruhestand (ÖD)' },
  { parameterId: 'SelfEmployed', parameterName: 'Selbstständige Personen' },
  { parameterId: 'HousePrivatier', parameterName: 'Haushaltsführende/Privatpersonen' },
  { parameterId: 'Farmer', parameterName: 'Tätige in der Landwirtschaft' },
  { parameterId: 'Student', parameterName: 'Studierende/Lernende' },
  { parameterId: 'Apprentice', parameterName: 'Auszubildende' },
  { parameterId: 'ProfessionalSoldier', parameterName: 'Militärangehörige' },
  { parameterId: 'NotWorking', parameterName: 'Ohne aktuelle Erwerbstätigkeit' },
];

export const MARITAL_STATUS_OPTIONS = [
  { parameterId: 'Single', parameterName: 'ledig' },
  { parameterId: 'Married', parameterName: 'verheiratet' },
  { parameterId: 'Divorced', parameterName: 'geschieden' },
  { parameterId: 'Widowed', parameterName: 'verwitwet' },
  { parameterId: 'LivingCommunity', parameterName: 'Lebensgemeinschaft' },
];

export const MARITAL_STATUS_PARTNER_OPTIONS = [
  { parameterId: 'Married', parameterName: 'verheiratet' },
  { parameterId: 'LivingCommunity', parameterName: 'Lebensgemeinschaft' },
];

export const HOUSING_TYPES = [
  { parameterId: 'None', parameterName: 'kein Wohneigentum' },
  { parameterId: 'House', parameterName: 'Haus' },
  { parameterId: 'Flat', parameterName: 'Wohnung' },
];

export const INDUSTRY_SECTORS = [
  { parameterId: 'ConstructionCraft', parameterName: 'Baugewerbe/Handwerk' },
  { parameterId: 'Mining', parameterName: 'Bergbau' },
  { parameterId: 'EnergyWater', parameterName: 'Energie-/Wasserversorgung' },
  { parameterId: 'Financing', parameterName: 'Finanz- und Versicherungsdienstleister' },
  { parameterId: 'Hospitality', parameterName: 'Gastgewerbe' },
  { parameterId: 'NonProfitOrganization', parameterName: 'gemeinnützige/mildtätige Einrichtung' },
  { parameterId: 'HealthSocial', parameterName: 'Gesundheits- und Sozialwesen' },
  { parameterId: 'Housing', parameterName: 'Grundstücks- und Wohnungswesen' },
  { parameterId: 'Trade', parameterName: 'Handel' },
  { parameterId: 'Industry', parameterName: 'Industrie/verarbeitendes Gewerbe' },
  { parameterId: 'Agriculture', parameterName: 'landwirtschaftliche Unternehmen' },
  { parameterId: 'PublicService', parameterName: 'öffentliche Verwaltung, Sozialversicherung' },
  { parameterId: 'OtherServices', parameterName: 'sonstige Dienstleistungen' },
  { parameterId: 'Others', parameterName: 'sonstiges' },
];

export const OTHER_NCD_CLASS_LIABILITY_OPTIONS = [
  {
    parameterId: 'SF_M',
    parameterName: 'SF M',
  },
  {
    parameterId: 'SF_S',
    parameterName: 'SF S',
  },
  {
    parameterId: 'SF_0',
    parameterName: 'SF 0',
  },
  {
    parameterId: 'SF_1_2',
    parameterName: 'SF 1/2',
  },
  {
    parameterId: 'SF01',
    parameterName: 'SF01',
  },
  {
    parameterId: 'SF02',
    parameterName: 'SF02',
  },
  {
    parameterId: 'SF03',
    parameterName: 'SF03',
  },
  {
    parameterId: 'SF04',
    parameterName: 'SF04',
  },
  {
    parameterId: 'SF05',
    parameterName: 'SF05',
  },
  {
    parameterId: 'SF06',
    parameterName: 'SF06',
  },
  {
    parameterId: 'SF07',
    parameterName: 'SF07',
  },
  {
    parameterId: 'SF08',
    parameterName: 'SF08',
  },
  {
    parameterId: 'SF09',
    parameterName: 'SF09',
  },
  {
    parameterId: 'SF10',
    parameterName: 'SF10',
  },
  {
    parameterId: 'SF11',
    parameterName: 'SF11',
  },
  {
    parameterId: 'SF12',
    parameterName: 'SF12',
  },
  {
    parameterId: 'SF13',
    parameterName: 'SF13',
  },
  {
    parameterId: 'SF14',
    parameterName: 'SF14',
  },
  {
    parameterId: 'SF15',
    parameterName: 'SF15',
  },
  {
    parameterId: 'SF16',
    parameterName: 'SF16',
  },
  {
    parameterId: 'SF17',
    parameterName: 'SF17',
  },
  {
    parameterId: 'SF18',
    parameterName: 'SF18',
  },
  {
    parameterId: 'SF19',
    parameterName: 'SF19',
  },
  {
    parameterId: 'SF20',
    parameterName: 'SF20',
  },
  {
    parameterId: 'SF21',
    parameterName: 'SF21',
  },
  {
    parameterId: 'SF22',
    parameterName: 'SF22',
  },
  {
    parameterId: 'SF23',
    parameterName: 'SF23',
  },
  {
    parameterId: 'SF24',
    parameterName: 'SF24',
  },
  {
    parameterId: 'SF25',
    parameterName: 'SF25',
  },
  {
    parameterId: 'SF26',
    parameterName: 'SF26',
  },
  {
    parameterId: 'SF27',
    parameterName: 'SF27',
  },
  {
    parameterId: 'SF28',
    parameterName: 'SF28',
  },
  {
    parameterId: 'SF29',
    parameterName: 'SF29',
  },
  {
    parameterId: 'SF30',
    parameterName: 'SF30',
  },
  {
    parameterId: 'SF31',
    parameterName: 'SF31',
  },
  {
    parameterId: 'SF32',
    parameterName: 'SF32',
  },
  {
    parameterId: 'SF33',
    parameterName: 'SF33',
  },
  {
    parameterId: 'SF34',
    parameterName: 'SF34',
  },
  {
    parameterId: 'SF35',
    parameterName: 'SF35',
  },
  {
    parameterId: 'SF36',
    parameterName: 'SF36',
  },
  {
    parameterId: 'SF37',
    parameterName: 'SF37',
  },
  {
    parameterId: 'SF38',
    parameterName: 'SF38',
  },
  {
    parameterId: 'SF39',
    parameterName: 'SF39',
  },
  {
    parameterId: 'SF40',
    parameterName: 'SF40',
  },
  {
    parameterId: 'SF41',
    parameterName: 'SF41',
  },
  {
    parameterId: 'SF42',
    parameterName: 'SF42',
  },
  {
    parameterId: 'SF43',
    parameterName: 'SF43',
  },
  {
    parameterId: 'SF44',
    parameterName: 'SF44',
  },
  {
    parameterId: 'SF45',
    parameterName: 'SF45',
  },
  {
    parameterId: 'SF46',
    parameterName: 'SF46',
  },
  {
    parameterId: 'SF47',
    parameterName: 'SF47',
  },
  {
    parameterId: 'SF48',
    parameterName: 'SF48',
  },
  {
    parameterId: 'SF49',
    parameterName: 'SF49',
  },
  {
    parameterId: 'SF50',
    parameterName: 'SF50',
  },
  {
    parameterId: 'SF51',
    parameterName: 'SF51',
  },
  {
    parameterId: 'SF52',
    parameterName: 'SF52',
  },
  {
    parameterId: 'SF53',
    parameterName: 'SF53',
  },
  {
    parameterId: 'SF54',
    parameterName: 'SF54',
  },
  {
    parameterId: 'SF55',
    parameterName: 'SF55',
  },
  {
    parameterId: 'SF56',
    parameterName: 'SF56',
  },
  {
    parameterId: 'SF57',
    parameterName: 'SF57',
  },
  {
    parameterId: 'SF58',
    parameterName: 'SF58',
  },
  {
    parameterId: 'SF59',
    parameterName: 'SF59',
  },
  {
    parameterId: 'SF60',
    parameterName: 'SF60',
  },
];

export const OTHER_NCD_CLASS_FULLY_COMPREHENSIVE_OPTIONS = [
  {
    parameterId: 'NONE',
    parameterName: 'keine',
  },
  {
    parameterId: 'SF_M',
    parameterName: 'SF M',
  },
  {
    parameterId: 'SF_0',
    parameterName: 'SF 0',
  },
  {
    parameterId: 'SF_1_2',
    parameterName: 'SF 1/2',
  },
  {
    parameterId: 'SF01',
    parameterName: 'SF01',
  },
  {
    parameterId: 'SF02',
    parameterName: 'SF02',
  },
  {
    parameterId: 'SF03',
    parameterName: 'SF03',
  },
  {
    parameterId: 'SF04',
    parameterName: 'SF04',
  },
  {
    parameterId: 'SF05',
    parameterName: 'SF05',
  },
  {
    parameterId: 'SF06',
    parameterName: 'SF06',
  },
  {
    parameterId: 'SF07',
    parameterName: 'SF07',
  },
  {
    parameterId: 'SF08',
    parameterName: 'SF08',
  },
  {
    parameterId: 'SF09',
    parameterName: 'SF09',
  },
  {
    parameterId: 'SF10',
    parameterName: 'SF10',
  },
  {
    parameterId: 'SF11',
    parameterName: 'SF11',
  },
  {
    parameterId: 'SF12',
    parameterName: 'SF12',
  },
  {
    parameterId: 'SF13',
    parameterName: 'SF13',
  },
  {
    parameterId: 'SF14',
    parameterName: 'SF14',
  },
  {
    parameterId: 'SF15',
    parameterName: 'SF15',
  },
  {
    parameterId: 'SF16',
    parameterName: 'SF16',
  },
  {
    parameterId: 'SF17',
    parameterName: 'SF17',
  },
  {
    parameterId: 'SF18',
    parameterName: 'SF18',
  },
  {
    parameterId: 'SF19',
    parameterName: 'SF19',
  },
  {
    parameterId: 'SF20',
    parameterName: 'SF20',
  },
  {
    parameterId: 'SF21',
    parameterName: 'SF21',
  },
  {
    parameterId: 'SF22',
    parameterName: 'SF22',
  },
  {
    parameterId: 'SF23',
    parameterName: 'SF23',
  },
  {
    parameterId: 'SF24',
    parameterName: 'SF24',
  },
  {
    parameterId: 'SF25',
    parameterName: 'SF25',
  },
  {
    parameterId: 'SF26',
    parameterName: 'SF26',
  },
  {
    parameterId: 'SF27',
    parameterName: 'SF27',
  },
  {
    parameterId: 'SF28',
    parameterName: 'SF28',
  },
  {
    parameterId: 'SF29',
    parameterName: 'SF29',
  },
  {
    parameterId: 'SF30',
    parameterName: 'SF30',
  },
  {
    parameterId: 'SF31',
    parameterName: 'SF31',
  },
  {
    parameterId: 'SF32',
    parameterName: 'SF32',
  },
  {
    parameterId: 'SF33',
    parameterName: 'SF33',
  },
  {
    parameterId: 'SF34',
    parameterName: 'SF34',
  },
  {
    parameterId: 'SF35',
    parameterName: 'SF35',
  },
  {
    parameterId: 'SF36',
    parameterName: 'SF36',
  },
  {
    parameterId: 'SF37',
    parameterName: 'SF37',
  },
  {
    parameterId: 'SF38',
    parameterName: 'SF38',
  },
  {
    parameterId: 'SF39',
    parameterName: 'SF39',
  },
  {
    parameterId: 'SF40',
    parameterName: 'SF40',
  },
  {
    parameterId: 'SF41',
    parameterName: 'SF41',
  },
  {
    parameterId: 'SF42',
    parameterName: 'SF42',
  },
  {
    parameterId: 'SF43',
    parameterName: 'SF43',
  },
  {
    parameterId: 'SF44',
    parameterName: 'SF44',
  },
  {
    parameterId: 'SF45',
    parameterName: 'SF45',
  },
  {
    parameterId: 'SF46',
    parameterName: 'SF46',
  },
  {
    parameterId: 'SF47',
    parameterName: 'SF47',
  },
  {
    parameterId: 'SF48',
    parameterName: 'SF48',
  },
  {
    parameterId: 'SF49',
    parameterName: 'SF49',
  },
  {
    parameterId: 'SF50',
    parameterName: 'SF50',
  },
  {
    parameterId: 'SF51',
    parameterName: 'SF51',
  },
  {
    parameterId: 'SF52',
    parameterName: 'SF52',
  },
  {
    parameterId: 'SF53',
    parameterName: 'SF53',
  },
  {
    parameterId: 'SF54',
    parameterName: 'SF54',
  },
  {
    parameterId: 'SF55',
    parameterName: 'SF55',
  },
  {
    parameterId: 'SF56',
    parameterName: 'SF56',
  },
  {
    parameterId: 'SF57',
    parameterName: 'SF57',
  },
  {
    parameterId: 'SF58',
    parameterName: 'SF58',
  },
  {
    parameterId: 'SF59',
    parameterName: 'SF59',
  },
  {
    parameterId: 'SF60',
    parameterName: 'SF60',
  },
];

export const NUMBER_OF_VEHICLES_OPTIONS = [
  {
    parameterId: '2',
    parameterName: '2',
  },
  {
    parameterId: '3',
    parameterName: '3',
  },
  {
    parameterId: '4',
    parameterName: '4',
  },
  {
    parameterId: '5',
    parameterName: '5',
  },
  {
    parameterId: '6',
    parameterName: '6',
  },
  {
    parameterId: '7',
    parameterName: '7',
  },
  {
    parameterId: '8',
    parameterName: '8',
  },
  {
    parameterId: '9',
    parameterName: '9',
  },
];

export const LIABILITY = [
  { parameterId: 'SF_M', parameterName: 'SF M' },
  { parameterId: 'SF_S', parameterName: 'SF S' },
  { parameterId: 'SF_0', parameterName: 'SF 0' },
  { parameterId: 'SF_1_2', parameterName: 'SF 1/2' },
  { parameterId: 'SF01', parameterName: 'SF01' },
  { parameterId: 'SF02', parameterName: 'SF02' },
  { parameterId: 'SF03', parameterName: 'SF03' },
  { parameterId: 'SF04', parameterName: 'SF04' },
  { parameterId: 'SF05', parameterName: 'SF05' },
  { parameterId: 'SF06', parameterName: 'SF06' },
  { parameterId: 'SF07', parameterName: 'SF07' },
  { parameterId: 'SF08', parameterName: 'SF08' },
  { parameterId: 'SF09', parameterName: 'SF09' },
  { parameterId: 'SF10', parameterName: 'SF10' },
  { parameterId: 'SF11', parameterName: 'SF11' },
  { parameterId: 'SF12', parameterName: 'SF12' },
  { parameterId: 'SF13', parameterName: 'SF13' },
  { parameterId: 'SF14', parameterName: 'SF14' },
  { parameterId: 'SF15', parameterName: 'SF15' },
  { parameterId: 'SF16', parameterName: 'SF16' },
  { parameterId: 'SF17', parameterName: 'SF17' },
  { parameterId: 'SF18', parameterName: 'SF18' },
  { parameterId: 'SF19', parameterName: 'SF19' },
  { parameterId: 'SF20', parameterName: 'SF20' },
  { parameterId: 'SF21', parameterName: 'SF21' },
  { parameterId: 'SF22', parameterName: 'SF22' },
  { parameterId: 'SF23', parameterName: 'SF23' },
  { parameterId: 'SF24', parameterName: 'SF24' },
  { parameterId: 'SF25', parameterName: 'SF25' },
  { parameterId: 'SF26', parameterName: 'SF26' },
  { parameterId: 'SF27', parameterName: 'SF27' },
  { parameterId: 'SF28', parameterName: 'SF28' },
  { parameterId: 'SF29', parameterName: 'SF29' },
  { parameterId: 'SF30', parameterName: 'SF30' },
  { parameterId: 'SF31', parameterName: 'SF31' },
  { parameterId: 'SF32', parameterName: 'SF32' },
  { parameterId: 'SF33', parameterName: 'SF33' },
  { parameterId: 'SF34', parameterName: 'SF34' },
  { parameterId: 'SF35', parameterName: 'SF35' },
  { parameterId: 'SF36', parameterName: 'SF36' },
  { parameterId: 'SF37', parameterName: 'SF37' },
  { parameterId: 'SF38', parameterName: 'SF38' },
  { parameterId: 'SF39', parameterName: 'SF39' },
  { parameterId: 'SF40', parameterName: 'SF40' },
  { parameterId: 'SF41', parameterName: 'SF41' },
  { parameterId: 'SF42', parameterName: 'SF42' },
  { parameterId: 'SF43', parameterName: 'SF43' },
  { parameterId: 'SF44', parameterName: 'SF44' },
  { parameterId: 'SF45', parameterName: 'SF45' },
  { parameterId: 'SF46', parameterName: 'SF46' },
  { parameterId: 'SF47', parameterName: 'SF47' },
  { parameterId: 'SF48', parameterName: 'SF48' },
  { parameterId: 'SF49', parameterName: 'SF49' },
  { parameterId: 'SF50', parameterName: 'SF50' },
  { parameterId: 'SF51', parameterName: 'SF51' },
  { parameterId: 'SF52', parameterName: 'SF52' },
  { parameterId: 'SF53', parameterName: 'SF53' },
  { parameterId: 'SF54', parameterName: 'SF54' },
  { parameterId: 'SF55', parameterName: 'SF55' },
  { parameterId: 'SF56', parameterName: 'SF56' },
  { parameterId: 'SF57', parameterName: 'SF57' },
  { parameterId: 'SF58', parameterName: 'SF58' },
  { parameterId: 'SF59', parameterName: 'SF59' },
  { parameterId: 'SF60', parameterName: 'SF60' },
];

export const FULLY_COMPREHENSIVE = [
  { parameterId: 'NONE', parameterName: 'keine' },
  { parameterId: 'SF_M', parameterName: 'SF M' },
  { parameterId: 'SF_0', parameterName: 'SF 0' },
  { parameterId: 'SF_1_2', parameterName: 'SF 1/2' },
  { parameterId: 'SF01', parameterName: 'SF01' },
  { parameterId: 'SF02', parameterName: 'SF02' },
  { parameterId: 'SF03', parameterName: 'SF03' },
  { parameterId: 'SF04', parameterName: 'SF04' },
  { parameterId: 'SF05', parameterName: 'SF05' },
  { parameterId: 'SF06', parameterName: 'SF06' },
  { parameterId: 'SF07', parameterName: 'SF07' },
  { parameterId: 'SF08', parameterName: 'SF08' },
  { parameterId: 'SF09', parameterName: 'SF09' },
  { parameterId: 'SF10', parameterName: 'SF10' },
  { parameterId: 'SF11', parameterName: 'SF11' },
  { parameterId: 'SF12', parameterName: 'SF12' },
  { parameterId: 'SF13', parameterName: 'SF13' },
  { parameterId: 'SF14', parameterName: 'SF14' },
  { parameterId: 'SF15', parameterName: 'SF15' },
  { parameterId: 'SF16', parameterName: 'SF16' },
  { parameterId: 'SF17', parameterName: 'SF17' },
  { parameterId: 'SF18', parameterName: 'SF18' },
  { parameterId: 'SF19', parameterName: 'SF19' },
  { parameterId: 'SF20', parameterName: 'SF20' },
  { parameterId: 'SF21', parameterName: 'SF21' },
  { parameterId: 'SF22', parameterName: 'SF22' },
  { parameterId: 'SF23', parameterName: 'SF23' },
  { parameterId: 'SF24', parameterName: 'SF24' },
  { parameterId: 'SF25', parameterName: 'SF25' },
  { parameterId: 'SF26', parameterName: 'SF26' },
  { parameterId: 'SF27', parameterName: 'SF27' },
  { parameterId: 'SF28', parameterName: 'SF28' },
  { parameterId: 'SF29', parameterName: 'SF29' },
  { parameterId: 'SF30', parameterName: 'SF30' },
  { parameterId: 'SF31', parameterName: 'SF31' },
  { parameterId: 'SF32', parameterName: 'SF32' },
  { parameterId: 'SF33', parameterName: 'SF33' },
  { parameterId: 'SF34', parameterName: 'SF34' },
  { parameterId: 'SF35', parameterName: 'SF35' },
  { parameterId: 'SF36', parameterName: 'SF36' },
  { parameterId: 'SF37', parameterName: 'SF37' },
  { parameterId: 'SF38', parameterName: 'SF38' },
  { parameterId: 'SF39', parameterName: 'SF39' },
  { parameterId: 'SF40', parameterName: 'SF40' },
  { parameterId: 'SF41', parameterName: 'SF41' },
  { parameterId: 'SF42', parameterName: 'SF42' },
  { parameterId: 'SF43', parameterName: 'SF43' },
  { parameterId: 'SF44', parameterName: 'SF44' },
  { parameterId: 'SF45', parameterName: 'SF45' },
  { parameterId: 'SF46', parameterName: 'SF46' },
  { parameterId: 'SF47', parameterName: 'SF47' },
  { parameterId: 'SF48', parameterName: 'SF48' },
  { parameterId: 'SF49', parameterName: 'SF49' },
  { parameterId: 'SF50', parameterName: 'SF50' },
  { parameterId: 'SF51', parameterName: 'SF51' },
  { parameterId: 'SF52', parameterName: 'SF52' },
  { parameterId: 'SF53', parameterName: 'SF53' },
  { parameterId: 'SF54', parameterName: 'SF54' },
  { parameterId: 'SF55', parameterName: 'SF55' },
  { parameterId: 'SF56', parameterName: 'SF56' },
  { parameterId: 'SF57', parameterName: 'SF57' },
  { parameterId: 'SF58', parameterName: 'SF58' },
  { parameterId: 'SF59', parameterName: 'SF59' },
  { parameterId: 'SF60', parameterName: 'SF60' },
];

export const LIABILITY_CLAIMS_NUMBER_OPTIONS = [
  { parameterId: LiabilityClaimsNumberEnum.ZERO, parameterName: '0' },
  { parameterId: LiabilityClaimsNumberEnum.ONE, parameterName: '1' },
  { parameterId: LiabilityClaimsNumberEnum.TWO, parameterName: '2' },
  { parameterId: LiabilityClaimsNumberEnum.THREE_AND_MORE, parameterName: '3 und mehr' },
];

export const PREVIOUS_INSURANCE_DURATION_OPTIONS = [
  {
    parameterId: PreviousInsuranceDurationEnum.LONGER_THAN_FIVE_YEAR,
    parameterName: 'länger als 5 Jahre',
  },
  {
    parameterId: PreviousInsuranceDurationEnum.LONGER_THAN_THREE_YEAR,
    parameterName: 'länger als 3 Jahre',
  },
  {
    parameterId: PreviousInsuranceDurationEnum.LONGER_THAN_ONE_YEAR,
    parameterName: 'länger als ein Jahr',
  },
  {
    parameterId: PreviousInsuranceDurationEnum.UP_TO_ONE_YEAR,
    parameterName: 'bis zu einem Jahr',
  },
  {
    parameterId: PreviousInsuranceDurationEnum.UNKNOWN,
    parameterName: 'unbekannt',
  },
];

export const COVERAGE_TYPES = [
  {
    id: 'Liability',
    value: 'Haftpflicht',
  },
  {
    id: 'PartiallyComprehensive',
    value: 'Teilkasko',
  },
  {
    id: 'FullyComprehensive',
    value: 'Vollkasko',
  },
];

export const GENDER_OPTIONS = [
  {
    parameterId: 'Female',
    parameterName: 'Frau',
  },
  {
    parameterId: 'Male',
    parameterName: 'Herr',
  },
  {
    parameterId: 'Divers',
    parameterName: 'ohne',
  },
];

export const TITLE_OPTIONS = [
  {
    parameterId: 'NONE',
    parameterName: 'ohne',
  },
  {
    parameterId: 'DR',
    parameterName: 'Dr.',
  },
  {
    parameterId: 'DR_MED',
    parameterName: 'Dr. med',
  },
  {
    parameterId: 'PROF',
    parameterName: 'Prof.',
  },
  {
    parameterId: 'PROF_MED',
    parameterName: 'Prof. med',
  },
];

export const VEHICLE_OWNER_KIND_OPTIONS = [
  {
    parameterId: VehicleOwnerKind.POLICYHOLDER_MAIN_RESIDENCE,
    parameterName: 'Ich (Versicherungsnehmer)',
  },
  {
    parameterId: VehicleOwnerKind.PARTNER_OF_POLICYHOLDER,
    parameterName: 'Mein Ehepartner',
  },
  {
    parameterId: VehicleOwnerKind.OTHER,
    parameterName: 'Jemand anderes',
  },
  {
    parameterId: VehicleOwnerKind.CHILD_OF_POLICYHOLDER,
    parameterName: 'Mein Kind mit Steuervergünstigung nach §3a Kraft StG',
  },
];

export const MONTHS = [
  {
    parameterId: 1,
    parameterName: 'Januar',
  },
  {
    parameterId: 2,
    parameterName: 'Februar',
  },
  {
    parameterId: 3,
    parameterName: 'März',
  },
  {
    parameterId: 4,
    parameterName: 'April',
  },
  {
    parameterId: 5,
    parameterName: 'Mai',
  },
  {
    parameterId: 6,
    parameterName: 'Juni',
  },
  {
    parameterId: 7,
    parameterName: 'Juli',
  },
  {
    parameterId: 8,
    parameterName: 'August',
  },
  {
    parameterId: 9,
    parameterName: 'September',
  },
  {
    parameterId: 10,
    parameterName: 'Oktober',
  },
  {
    parameterId: 11,
    parameterName: 'November',
  },
  {
    parameterId: 12,
    parameterName: 'Dezember',
  },
];

export const PREVIOUS_INSURER_OPTIONS = [
  { parameterId: '5055', parameterName: 'Verti Versicherung AG' },
  { parameterId: '5862', parameterName: 'VHV Allgemeine Versicherung AG' },
  { parameterId: '5521', parameterName: 'HUK-COBURG-Allgemeine Versicherung AG' },
  { parameterId: '5513', parameterName: 'DEVK Allgemeine Versicherungs-AG' },
  { parameterId: '5552', parameterName: 'Cosmos Versicherung AG' },
  { parameterId: '5312', parameterName: 'Allianz Versicherungs-AG' },
  { parameterId: '5525', parameterName: 'WGV-Versicherung AG' },
  { parameterId: '5137', parameterName: 'R+V Direktversicherung AG' },
  { parameterId: '5515', parameterName: 'AXA Versicherung AG' },
  { parameterId: '5343', parameterName: 'DA Deutsche Allgemeine Versicherung AG' },
  { parameterId: '5086', parameterName: 'HUK24 AG' },
  { parameterId: '5135', parameterName: 'ADAC Autoversicherung AG' },
  { parameterId: '5441', parameterName: 'AllSecur Deutschland AG' },
  { parameterId: '5085', parameterName: 'HDIVersicherung AG' },
  { parameterId: '5402', parameterName: 'LVM a.G.' },
  { parameterId: '5508', parameterName: 'EUROPA Versicherung AG' },
  { parameterId: '5438', parameterName: 'R+V Allgemeine Versicherung AG' },
  { parameterId: '5342', parameterName: 'AachenMünchener Versicherung AG' },
  { parameterId: '5581', parameterName: 'ADLER Versicherung AG' },
  { parameterId: '1113', parameterName: 'AdmiralDirekt.de GmbH' },
  { parameterId: '5206', parameterName: 'AIG Europe SE' },
  { parameterId: '5029', parameterName: 'AIOI Motor and General Insurance' },
  { parameterId: '9390', parameterName: 'A-I-S Wild (Gefion)' },
  { parameterId: '5405', parameterName: 'Alte Leipziger Versicherung AG' },
  { parameterId: '5068', parameterName: 'Ammerländer Versicherungsverein a.G.' },
  { parameterId: '5455', parameterName: 'ARAG Allgemeine Versicherungs-AG' },
  { parameterId: '5132', parameterName: 'Avetas Versicherungs-AG' },
  { parameterId: '5155', parameterName: 'AXA easy Versicherung AG' },
  { parameterId: '5316', parameterName: 'Badischer Gemeinde-Versicherungs-Verband' },
  { parameterId: '5317', parameterName: 'Barmenia Allgemeine Versicherungs-AG' },
  { parameterId: '5633', parameterName: 'Basler Sachversicherungs-AG' },
  { parameterId: '1114', parameterName: 'BavariaDirekt' },
  { parameterId: '5310', parameterName: 'Bayerische Beamten Versicherung AG' },
  { parameterId: '5325', parameterName: 'Bayerische Versicherungsbank' },
  { parameterId: '5324', parameterName: 'Bayerischer Versicherungsverband VersicherungsAG' },
  { parameterId: '5146', parameterName: 'BGV-Versicherung AG' },
  { parameterId: '5098', parameterName: 'Bruderhilfe Sachversicherung AG' },
  { parameterId: '5338', parameterName: 'Concordia Versicherungs-Gesellschaft' },
  { parameterId: '5339', parameterName: 'Condor Allgemeine Versicherungs-AG' },
  { parameterId: '5340', parameterName: 'Continentale Sachversicherung AG' },
  { parameterId: '5049', parameterName: 'Cordial Versicherung AG' },
  { parameterId: '5771', parameterName: 'Darag' },
  { parameterId: '5311', parameterName: 'DBV Deutsche Beamtenversicherung AG' },
  { parameterId: '5549', parameterName: 'Debeka Allgemeine Versicherung AG' },
  { parameterId: '5084', parameterName: 'Deutsche Internet Versicherung' },
  { parameterId: '5344', parameterName: 'DEVK Deutsche Eisenbahn Versicherung' },
  { parameterId: '5210', parameterName: 'Dialog Versicherung AG' },
  { parameterId: '5858 100', parameterName: 'EMIL Deutschland AG' },
  { parameterId: '5562', parameterName: 'ERGO Direkt Versicherung AG' },
  { parameterId: '5472', parameterName: 'ERGO Versicherung AG' },
  { parameterId: '5902', parameterName: 'European Group Limited' },
  { parameterId: '5470', parameterName: 'Fahrlehrerversicherung Verein auf Gegenseitigkeit' },
  { parameterId: '5024', parameterName: 'Feuersozietät Berlin Brandenburg Versicherung AG' },
  { parameterId: '5312 010', parameterName: 'Fiat Versicherungsdienst' },
  { parameterId: '5209', parameterName: 'FRIDAY' },
  { parameterId: '5505', parameterName: 'Garanta Versicherungs-AG' },
  { parameterId: '5033', parameterName: 'GAV Versicherungs AG' },
  { parameterId: '523', parameterName: 'GHV Darmstadt' },
  { parameterId: '5858', parameterName: 'Gothaer Allgemeine Versicherung AG' },
  { parameterId: '5365', parameterName: 'GVO Gegenseitigkeit Versicherung Oldenburg VVaG' },
  { parameterId: '5469', parameterName: 'GVV-Kommunalversicherung Versicherungsverein' },
  { parameterId: '5585', parameterName: 'GVV-Privatversicherung AG' },
  { parameterId: '5032', parameterName: 'Hamburger Feuerkasse Versicherungs-AG' },
  { parameterId: '5501', parameterName: 'HanseMerkur Allgemeine Versicherung AG' },
  { parameterId: '5178', parameterName: 'HDI Gobal' },
  { parameterId: '5096', parameterName: 'HDI-Gerling Industrie Versicherung AG' },
  { parameterId: '5384', parameterName: 'Helvetia AG' },
  { parameterId: '5375', parameterName: 'HUK-COBURG' },
  { parameterId: '5390', parameterName: 'Iduna' },
  { parameterId: '7587', parameterName: 'Ineas Versicherung' },
  { parameterId: '5401', parameterName: 'Itzehoer Versicherung' },
  { parameterId: '5078', parameterName: 'Janitos Versicherung AG' },
  { parameterId: '5509', parameterName: 'Karlsruher Versicherung AG' },
  { parameterId: '9999', parameterName: 'keine Vorversicherung' },
  { parameterId: '5550', parameterName: 'Kraft' },
  { parameterId: '5058', parameterName: 'KRAVAG-ALLGEMEINE Versicherungs-AG' },
  { parameterId: '5080', parameterName: 'KRAVAG-LOGISTIC Versicherungs-AG' },
  { parameterId: '5362', parameterName: 'Landesschadenhilfe Versicherung VaG' },
  { parameterId: '5400', parameterName: 'Landschaftliche Brandkasse Hannover' },
  { parameterId: '5232', parameterName: 'Lippische Landesbrandkasse AG' },
  { parameterId: '5061', parameterName: 'Mannheimer Versicherung AG' },
  { parameterId: '5412', parameterName: 'Mecklenburgische Versicherungs-Gesellschaft' },
  { parameterId: '5414', parameterName: 'Münchener Verein Allgemeine Versicherungs-AG' },
  { parameterId: '5070', parameterName: 'NEXIBLE Versicherung AG' },
  { parameterId: '5680', parameterName: 'Nippon Insurance Company of Europe LTD' },
  { parameterId: '5426', parameterName: 'Nürnberger Allgemeine Versicherungs-AG' },
  { parameterId: '5686', parameterName: 'Nürnberger Beamten Versicherung AG' },
  { parameterId: '522', parameterName: 'Öffentliche Feuerversicherung Sachsen-Anhalt' },
  { parameterId: '501', parameterName: 'Öffentliche Sachversicherung Braunschweig' },
  { parameterId: '506', parameterName: 'Oldenburgische Landesbrandkasse' },
  { parameterId: '9496', parameterName: 'ONE Versicherung AG' },
  { parameterId: '5312 009', parameterName: 'Opel-Händler Versicherungsdienst GmbH' },
  { parameterId: '5787', parameterName: 'OVAG Ostdeutsche Versicherung AG' },
  { parameterId: '5432', parameterName: 'Patria Versicherung' },
  { parameterId: '5446', parameterName: 'Provinzial Nord Brandkasse AG' },
  { parameterId: '5095', parameterName: 'Provinzial Rheinland Versicherung AG' },
  { parameterId: '5798', parameterName: 'RheinLand Versicherungs AG' },
  { parameterId: '5121', parameterName: 'Rhion Versicherung AG' },
  { parameterId: '5051', parameterName: 'S DirektVersicherung AG' },
  { parameterId: '5773', parameterName: 'SAARLAND Feuerversicherung AG' },
  { parameterId: '5448', parameterName: 'Schweizer-National Versicherungs-AG' },
  { parameterId: '5450', parameterName: 'Securitas' },
  { parameterId: '5125', parameterName: 'SIGNAL IDUNA Allgemeine Versicherung AG' },
  { parameterId: '5781', parameterName: 'Sparkassen-Versicherung AG' },
  { parameterId: '5036', parameterName: 'SV SparkassenVersicherung Gebäudeversicherung AG' },
  { parameterId: '5459', parameterName: 'Uelzener Allgemeine Versicherungs-Gesellschaft a.G.' },
  { parameterId: '5463', parameterName: 'uniVersa Allgemeine Versicherung AG' },
  { parameterId: '7258', parameterName: 'VAV Versicherung' },
  { parameterId: '5042', parameterName: 'Versicherungskammer Bayern' },
  { parameterId: '5169', parameterName: 'Volkswagen Autoversicherung AG' },
  { parameterId: '1112', parameterName: 'Volkswagen Versicherungsdienst GmbH' },
  { parameterId: '5484', parameterName: 'Volkswohl-Bund Sachversicherung AG' },
  { parameterId: '5152', parameterName: 'W.R. Berkley Insurance' },
  { parameterId: '5093', parameterName: 'Westfälische Provinzial Versicherung AG' },
  { parameterId: '5479', parameterName: 'Württembergische Gemeinde-Versicherung' },
  { parameterId: '5783', parameterName: 'Württembergische Versicherung AG' },
  { parameterId: '5476', parameterName: 'WWK Allgemeine Versicherung AG' },
  { parameterId: '7929', parameterName: 'Zurich Connect' },
  { parameterId: '5151', parameterName: 'Zurich Versicherung' },
];

export const FUEL_TYPES = [
  { parameterId: 'Other', parameterName: 'sonstiges' },
  { parameterId: 'Petrol', parameterName: 'Benzin' },
  { parameterId: 'Diesel', parameterName: 'Diesel' },
  { parameterId: 'Electric', parameterName: 'Elektro' },
  { parameterId: 'Gas', parameterName: 'Gas' },
  { parameterId: 'Hydrogen', parameterName: 'Wasserstoff' },
  { parameterId: 'Hybrid', parameterName: 'Hybrid' },
  { parameterId: 'PetrolElectric', parameterName: 'Hybrid' },
  { parameterId: 'DieselElectric', parameterName: 'Hybrid' },
  { parameterId: 'PetrolElectricPlugIn', parameterName: 'Hybrid' },
  { parameterId: 'DieselElectricPlugIn', parameterName: 'Hybrid' },
];

export const CAR_TYPES = [
  { parameterId: 'Bus', parameterName: 'Bus' },
  { parameterId: 'Cabrio_open', parameterName: 'Cabrio' },
  { parameterId: 'Coupe', parameterName: 'Coupe' },
  { parameterId: 'Limousine', parameterName: 'Limousine' },
  { parameterId: 'Other', parameterName: 'Sonstiges' },
  { parameterId: 'SUV', parameterName: 'SUV' },
  {
    parameterId: 'Transporter_closed',
    parameterName: 'Transporter',
  },
  {
    parameterId: 'Transporter_platform',
    parameterName: 'Transporter',
  },
  { parameterId: 'Wagon', parameterName: 'Kombi' },
];

export const OFFERS = [
  { parameterId: 'Basic', parameterName: 'Basis' },
  { parameterId: 'Classic', parameterName: 'Klassik' },
  { parameterId: 'Premium', parameterName: 'Premium' },
  { parameterId: 'PlusBonus', parameterName: 'PlusBonus' },
];

export const DEFAULT_PAYMENT_OPTIONS = [
  {
    frequency: 'Yearly',
    kind: 'Debit',
    value: 'jährlich per Lastschrift',
  },
  {
    frequency: 'HalfYearly',
    kind: 'Debit',
    value: 'halbjährlich per Lastschrift',
  },
  {
    frequency: 'Quarterly',
    kind: 'Debit',
    value: 'vierteljährlich per Lastschrift',
  },
];

export const DEFAULT_PAYMENT_OPTIONS_INSURER_CANCELLED = [
  {
    frequency: 'Yearly',
    kind: 'Transfer',
    value: 'jährlich per Überweisung',
  },
];

export const VEHICLE_CATEGORIES_TRANSLATE = [
  { id: 'Bus', value: 'Bus' },
  { id: 'Cabrio_open', value: 'Cabrio' },
  { id: 'Coupe', value: 'Coupe' },
  { id: 'Limousine', value: 'Limousine' },
  { id: 'Other', value: 'Sonstiges' },
  { id: 'SUV', value: 'SUV' },
  {
    id: 'Transporter_closed',
    value: 'Transporter',
  },
  {
    id: 'Transporter_platform',
    value: 'Transporter',
  },
  { id: 'Wagon', value: 'Kombi' },
];

export const VEHICLE_FUEL_TYPES_TRANSLATE = [
  { id: 'Other', value: 'sonstiges' },
  { id: 'Petrol', value: 'Benzin' },
  { id: 'Diesel', value: 'Diesel' },
  { id: 'Electric', value: 'Elektro' },
  { id: 'Gas', value: 'Gas' },
  { id: 'Hydrogen', value: 'Wasserstoff' },
  { id: 'Hybrid', value: 'Hybrid' },
  { id: 'PetrolElectric', value: 'Hybrid' },
  { id: 'DieselElectric', value: 'Hybrid' },
  { id: 'PetrolElectricPlugIn', value: 'Hybrid' },
  { id: 'DieselElectricPlugIn', value: 'Hybrid' },
];
